import Reflux from 'reflux';

const StripeActions = Reflux.createActions(['change']);

export default StripeActions;
